"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var ToggleButton_1 = __importDefault(require("shared/components/Button/ToggleButton/ToggleButton"));
var Text_1 = __importDefault(require("shared/components/Text"));
var BillingFrequencyForm = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Billing Frequency" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ my: 1 }, { children: (0, jsx_runtime_1.jsxs)(material_1.ToggleButtonGroup, __assign({ value: value, onChange: function (e, newValue) { return onChange(newValue); }, "aria-label": "billing frequency", size: "small", exclusive: true, fullWidth: true, disabled: disabled }, { children: [(0, jsx_runtime_1.jsx)(ToggleButton_1.default, __assign({ value: "monthly", "aria-label": "Monthly", color: "primary" }, { children: "Monthly" })), (0, jsx_runtime_1.jsx)(ToggleButton_1.default, __assign({ value: "yearly", "aria-label": "Yearly", color: "secondary" }, { children: "Yearly" }))] })) }))] }));
};
exports.default = BillingFrequencyForm;
